module.exports = __webpack_public_path__ + "static/atlas-hero-background-d901149f4b532fc717205a32f231dcd5.png";